<template>
    <div style="width:100%; height: 100%; background-image: url('/img/bgd-banner.jpg')">
        <v-container>
            <v-row align="center" justify="center">
                <v-col cols="6">
                    <v-form @submit.prevent="onSubmit">
                        <v-card>
                            <v-card-title dark class="white--text" style="background-color:#00aeef">
                                Password Reset</v-card-title
                            >
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-text-field
                                    v-model="formPassword1"
                                    label="New Password"
                                    type="password"
                                    autocomplete="current-password"
                                    required
                                ></v-text-field>
                                <v-text-field
                                    v-model="formPassword2"
                                    label="Repeat New Password"
                                    type="password"
                                    autocomplete="current-password"
                                    required
                                ></v-text-field>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn type="submit" color="primary" :loading="inProgress" :disabled="inProgress"
                                    >Submit</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

export default Vue.extend({
    data() {
        return {
            formPassword1: '',
            formPassword2: '',
            inProgress: false
        }
    },
    methods: {
        async onSubmit() {
            this.inProgress = true
            let token = this.$route.query.x
            if (typeof token !== 'string') {
                throw new Error('Invalid token')
            }
            if (this.formPassword1 !== this.formPassword2) {
                this.$store.commit('showSnackbar', {
                    message: 'Passwords do not match',
                    context: 'error'
                })
                return
            }

            axios
                .post(this.$store.state.resetPwSubmitUrl, {
                    token,
                    newPassword: this.formPassword1
                })
                .then(response => {
                    this.$store.commit('showSnackbar', {
                        message: response.data,
                        context: 'success'
                    })
                    this.formPassword1 = ''
                    this.formPassword2 = ''
                    this.$router.replace('/')
                })
                .catch(error => {
                    this.$store.commit('showSnackbar', {
                        message: error.response ? error.response.data : 'Network error',
                        context: 'error'
                    })
                })
                .finally(() => {
                    this.inProgress = false
                })
        }
    }
})
</script>
